import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import Radio from '../../Components/Radio_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
function PM10040(props) {
    React.useEffect(() => {
        document.title = '자재입고현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '구매관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>자재입고현황</strong>" +
            '</h1>';
    }, []);
    const [selectedRadio, setSelectedRadio] = React.useState('0');
    const gridRef = React.useRef();
    const autoGroupColumnDef = React.useMemo(() => {
        //그룹설정
        return {
            headerName: '거래처명',
            minWidth: 330,
        };
    }, []);
    const columnDefs = {
        columnDefs: [
            //발주일자
            {
                field: 'poCreateDt',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_ProcessOrderDate' && f.lanType === 'COL')[0]
                              .lanName
                        : '',
                minWidth: 100,
            },
            //입고일자
            {
                field: 'stockInDt',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_StockInDate' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
            },
            //거래처
            {
                field: 'custNm',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                        : '',
                cellRenderer: 'agGroupCellRenderer',
                rowGroup: selectedRadio === '1' ? true : false,
                minWidth: 190,
            },

            //품목명
            {
                field: 'itemNm',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 300,
            },
            //발주수량
            {
                field: 'poAddItemQty',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                        : '',
                valueFormatter: (params) => {
                    var formatted = params.value
                        ? parseFloat(params.value)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                        : '';
                    return formatted;
                },
                cellStyle: { textAlign: 'right' },
                aggFunc: 'sum',
                minWidth: 150,
            },
            //수량(BOM)
            {
                field: 'poItemQty',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_PoItemBomQty' && f.lanType === 'COL')[0].lanName
                        : '',
                valueFormatter: (params) => {
                    var formatted = params.value
                        ? parseFloat(params.value)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                        : '';
                    return formatted;
                },
                cellStyle: { textAlign: 'right' },
                aggFunc: 'sum',
                minWidth: 150,
            },
            //입고수량
            {
                field: 'inAddQty',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_InQty' && f.lanType === 'COL')[0].lanName
                        : '',
                valueFormatter: (params) => {
                    var formatted = params.value
                        ? parseFloat(params.value)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                        : '';
                    return formatted;
                },
                cellStyle: { textAlign: 'right' },
                aggFunc: 'sum',
                minWidth: 150,
            },
            //입고수량(Bom)
            {
                field: 'inQty',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_InQtyBom' && f.lanType === 'COL')[0].lanName
                        : '',
                valueFormatter: (params) => {
                    var formatted = params.value
                        ? parseFloat(params.value)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                        : '';
                    return formatted;
                },
                cellStyle: { textAlign: 'right' },
                aggFunc: 'sum',
                minWidth: 150,
            },
            //단위
            {
                field: 'itemUnit',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
            },
            //단가
            {
                field: 'itemStdAmt',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
                cellStyle: { textAlign: 'right' },
            },
            //금액
            {
                field: 'inItemAmt',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                        : '',
                valueFormatter: (params) => {
                    var formatted = params.value
                        ? parseFloat(params.value)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                        : '';
                    return formatted;
                },
                cellStyle: { textAlign: 'right' },
                aggFunc: 'sum',
                minWidth: 100,
            },
            //입고창고
            {
                field: 'inWhNm',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_InWhCd' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 130,
                cellRenderer: Commons.CustomWhCdRenderer,
            },
            //발주번호
            {
                field: 'poNo',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_PoNo' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
            },
            //입고번호
            {
                field: 'stockInNo',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_StockInNo' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
            },
            //품목코드
            {
                field: 'itemCd',
                headerName:
                    props.lanData.length > 0
                        ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                        : '',
                minWidth: 100,
            },
        ],
        defaultColDef: {
            flex: 1,
            minWidth: 190,
            sortable: true,
            resizable: true,
        },
        autoGroupColumnDef: {
            minWidth: 200,
        },
        animateRows: true,
    };

    const onCellClicked = (e) => {
        const selected = e.data;
        // props.setCheckCustCd(selected.CustCd);
        // props.setInputs({
        //   ...props.inputs,
        //   CustCd: selected.CustCd,
        //   CeoNm: selected.CeoNm,
        //   CustNm: selected.CustNm,
        //   EMail: selected.EMail,
        //   Address1: selected.Address1,
        //   CorpLicenNo: selected.CorpLicenNo,
        // });
    };
    return (
        <div>
            <div>
                <div style={{ height: '50%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Fom_ReceivingDate' && f.lanType === 'FORM'
                                  )[0].lanName
                                : ''}
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.startDate}
                                onChange={(e) => {
                                    props.setStartDate(e);
                                }}
                            />
                            ~
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginLeft: '5px' }}
                                selected={props.endDate}
                                onChange={(e) => {
                                    props.setEndDate(e);
                                }}
                            />
                            <Radio
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                items={[
                                    //전체
                                    {
                                        value: '0',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Radio_All' && f.lanType === 'RADIO'
                                                  )[0].lanName
                                                : '',
                                    },
                                    //거래처
                                    {
                                        value: '1',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Radio_CustName' && f.lanType === 'RADIO'
                                                  )[0].lanName
                                                : '',
                                    },
                                ]}
                                value={selectedRadio}
                                onChange={(e) => {
                                    setSelectedRadio(e.target.value);
                                }}
                            />
                        </div>
                        <AuthGroupButton
                            pageName="PM10020"
                            target="G01"
                            refreshNone="none"
                            refreshFunc={() => {
                                props.Init();
                            }}
                            addFunc={() =>
                                // gridRef.current.api.setRowData([{}, ...props.rowData])
                                props.setModalToggle(true)
                            }
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs.columnDefs}
                            groupIncludeTotalFooter={true}
                            autoGroupColumnDef={autoGroupColumnDef}
                            suppressAggFuncInHeader={true}
                            defaultColDef={{
                                minWidth: 190,
                                flex: 1,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
                            }
                            onCellClicked={onCellClicked}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PM10040;
